import styled from 'styled-components';

export const MetricList = styled.div`
    max-width: 820px;
    width: calc(100% - 32px);
    flex-grow: 0;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    gap: 24px;
    padding: 16px;
    border-radius: 8px;
    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.3);
    background-color: var(--neutral-0);
`;

export const Separator = styled.div`
    width: 100%;
    height: 1px;
    background-color: var(--neutral-100);
`;

export const MetricListItem = styled.div`
    align-self: stretch;
    flex-grow: 0;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 12px;
    padding: 0;
`;

export const MetricResult = styled.p`
    color: var(--text-400);
`;
